
export const CardLinksData = [
  {
    text: 't("app.home-card")',
    image: '/images/CHome.png',
    link: '/insurance/housing',
    describe: 't("app.home-card-description")',
    startingFrom: 't("app.home-card-starting-from")',
    color: '#2F6472',
    icon: 'home',
    displayForCS: 'block',
    newO: false,
    value: 'home'
  },
  {
    text: 't("app.health-mobility-card")',
    image: '/images/CHealthMobility.png',
    link: '/insurance/health-mobility',
    describe: 't("app.health-mobility-card-description")',
    color: '#2F6472',
    icon: 'flight',
    displayForCS: 'none',
    newO: false,
    value:'health/mobility'

  },
  // {
  //   text: 't("app.multimedia-card")',
  //   image: '/images/CMultimedia.png',
  //   link: '/insurance/multimedia',
  //   color: '#2F6472',
  //   icon: 'laptop',
  //   newO:  false,
  //   value: 'multimedia'
  // },
  {
    text: 't("app.health-mutual-card")',
    image: '/images/CMutual.png',
    link: '/insurance/health-mutual',
    describe: 't("app.health-mutual-card-description")',
    color: '#2F6472',
    icon: 'mutual',
    displayForCS: 'block',
    newO: false,
    value: 'mutual'
  },
  {
    text: 't("app.rc-card")',
    image: '/images/CRc.png',
    link: '/insurance/rc',
    describe: 't("app.rc-card-description")',
    startingFrom: 't("app.rc-card-starting-from")',
    color: '#2F6472',
    icon: 'rc',
    displayForCS: 'block',
    newO: true,
    value: 'rc'
  }
];